import React from 'react';
import { connect } from 'react-redux';

import { Form } from 'components/common';
import MainFieldSet from './MainFieldSet';

const NavFooterForm = (props) => {
  const { showEditForm } = props.navFooter;

  const onClose = () => {
    props.actions.navFooter.showEditForm({ show: false });
  };

  const onSubmit = (data) => {
    const newData = Object.assign(data, {
      site: props.site.activeId,
      page: data.page ? data.page: null,
    });
    props.actions.navFooter.update(newData);
  };

  return (
    <Form
      width={800}
      title="Редактирование навигации"
      model={props.navFooter}
      visible={showEditForm}
      onClose={onClose}
      onSubmit={onSubmit}
      initialValues={{ sort: 100 }}
      convertEditObject={(editObject) => ({
        ...editObject,
        page: editObject.page ? editObject.page.id: null,
      })}
    >
      <MainFieldSet {...props} />
    </Form>
  );
};

const mapState = (state) => ({
  site: state.site,
  auth_token: state.auth.token,
  navFooter: state.navFooter,
});

const mapDispatch = (dispatch) => ({
  actions: {
    navFooter: dispatch.navFooter,
  },
});

export default connect(mapState, mapDispatch)(NavFooterForm);
